import { IEnabledGame, IResponseInitial } from '@bg-shared/infrastructure/Initial/interfaces';
import { ClassicGameDefinition } from '@bg-shared/utils/ClassicGameDefinition';

export const isInHouseGame = (game: IResponseInitial['enabledGames'][0]): game is IEnabledGame => {
    return !ClassicGameDefinition.isPLSGame(game.gameId);
};
